define('views/modules/setting/business/blocks/custom-button/custom-button',[
    // Libs
    'underscore', 'backbone', 'mustache', 'moment', 'utils',
    // services
    'services/i18n',
    // views
    'views/parts/info-section',
    'views/modules/setting/business/blocks/custom-button/custom-button-edit-panel',
    'views/parts/form/button',
    // templates
    'text!templates/modules/setting/business/blocks/custom-button/custom-button.html'

], function(
    // Libs
    _, Backbone, Mustache, moment, U,
    // services
    i18n,
    // views
    VInfoSection,
    VCustomButtonEditPanel,
    VButton,
    // templates
    TCustomButton
) {

    var VCustomButton = Backbone.Epoxy.View.extend({
        template: TCustomButton,

        regions: {
            preview: '.button-preview',
        },

        initialize: function(opt) {
            this.options = opt || {};

            _.extend(this, {
                group: opt.group
            });

            var group = this.group,
                view = this.view = {
                    info: new VInfoSection({
                        title: "Your custom button",
                        icon: "sl-icon-settings",
                        help: "messages:helpbox-business-custom-button",
                        buttonBottom: {
                            text: "Edit my custom button",
                            context: this,
                            callback: this.onEditCustomButton
                        },
                        content: this.template,
                    }),
                    preview: new VButton({
                        label: this.group.get('customButtonText'),
                        callback: this.onClearAllMessages,
                        context: this,
                        url: this.group.get('customButtonUrl'),
                        target: '_blank',
                        external: true,
                        icon: false,
                        class: 'btn-rounded',
                    }),
                };

            this.listenTo(group, 'change:customButton', this.onCustomButtonChange);
            this.listenTo(this.model, 'sync', this.onModelSync);
        },

        render: function(model) {

            var view = this.view;
            this.assign(view.info, this.$el) // must be first
                .applyBindings();

            this.generateZones();

            this.assign(view.preview, this.zone.$preview);

            return this;
        },

        setCustomButtonTitle: function(model) {
          var content = Backbone.$('#setting-custom-button.info-section').text();
          if (model && model.get("customButton") && model.get("customButton") === false || model.get("customButton").active === false) {
            this.view.info.setTitle(i18n.t("Your custom button") + " (" + i18n.t("Button Disabled") + ")");
          } else {
            this.view.info.setTitle(i18n.t("Your custom button"));
          }
        },

        ////////////
        // events //
        ////////////
        onModelSync: function(model) {
          if (model) {
            this.setCustomButtonTitle(model);
          } else {
            this.setCustomButtonTitle(this.model);
          }

        },

        onEditCustomButton: function(e) {
            e.preventDefault();
            var view = this.view,
                panel = view.edit || (view.edit = new VCustomButtonEditPanel({
                    model: this.group
                }));
            this.trigger('panel:stack', panel);
        },

        onCustomButtonChange: function(model, value) {
            var button = this.view.preview;

            this.setCustomButtonTitle(model);
            this.view.info.render();

            button.setLabel(model.get('customButtonText'));
            button.setUrl(model.get('customButtonUrl'));
            button.options.label = model.get('customButtonText');
            button.options.url = model.get('customButtonUrl');
            this.applyBindings();
            this.render(model);

        },

    });

    return VCustomButton;
});

